import React, { Component } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { stateMappings } from '../redux/stateMappings';
import { userEdit } from '../redux/auth/thunks';
import { setWeerdyModal } from '../redux/modal/thunks';
import { setToast } from '../lib/toast';

Modal.setAppElement('#root');

class PasswordChangeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      isEdit: false,
    };
  }

  onChange = ({ target: { name, value } }) =>
    this.setState(state => ({
      ...state,
      [name]: value,
    }));

  handleSubmit = async (e) => {
    e.preventDefault();

    const { password } = this.state;
    const { editUser, setModal, currentUser } = this.props;

    if (!password) {
      setToast('error', "Please input password.");
      return;
    }

    try {
      await editUser({
        _id: currentUser._id,
        password,
      });
    } catch (error) {
      return;
    }

    this.displayEdit();
    setModal('passwordChangeModalOpen');
  };

  displayEdit = () => {
    this.setState({
      isEdit: !this.state.isEdit,
    });
  }

  render() {
    const {
      open,
      isOpen,
      customStyles,
    } = this.props;

    const { password, isEdit } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={(e) => open(e, "passwordChangeModalOpen")}
        closeTimeoutMS={500}
        style={customStyles}
        className="modal fade show"
      >
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content crudModal p-8 sm:p-4 position-relative">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-lg-12 text-center">
                  <img className="action-sure-image" src="./images/edit.svg" alt="" /> <h5 className="fw-bold">Edit Your User Password</h5>
                </div>
                <div className={`col-lg-12 text-center mt-16 sm:mt-8 editable-cell${isEdit ? ' editing' : ''}`}>
                  <input name="password" value={isEdit ? password : '**************'} onChange={this.onChange} className="dotted-input editable-input" type="text" placeholder="" readOnly={!isEdit}/>
                </div>
              </div>
              <DivContainer className="row d-flex justify-content-between mt-12 sm:mt-8">
                <a href="#" onClick={(e) => open(e, "passwordChangeModalOpen")} className="button red radius border-black fs-poppins">Cancel</a>
                {!isEdit && <a href="#" onClick={this.displayEdit} className="button green radius border-black fs-poppins edit-button">Edit</a>}
                {isEdit && <button type="submit" className="button green radius border-black fs-poppins save-button show" style={{ height: 36 }}>Save</button>}
              </DivContainer>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = ( state ) => {
  const sm = stateMappings(state);

  return {
    isAuthenticated: sm.isAuthenticated,
    currentUser: sm.user,
  };
};

const mapActionsToProps = {
  setModal: setWeerdyModal,
  editUser: userEdit,
}

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(PasswordChangeModal);

const DivContainer = styled.div`
  .save-button {
    height: 36px;
    font-size: 16px;
    padding: 4px 24px;
  }
`
